/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
    this.querySelector('[data-more-colors]')?.addEventListener('click', (event) => {
      this.manageColors(event);
    });

    
  }

  manageColors(event){
    event.preventDefault();
    this.querySelectorAll('[data-hidden-colors]').forEach((el) => {
      el.classList.remove("d-none");
    });
    event.currentTarget.classList.add('d-none');
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
     
      if (res.errors == 'Cart Error') {
          window.notificationEle.updateNotification('Add to Cart', 'This products has limited quantity available', {
            type: 'error',
            timeout: 5000
          });
      } else {
          let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));

          let recipientForm = document.querySelector('recipient-form');
          
       
          if(dataJSON.errors){

            if(recipientForm){
              window.notificationEle.updateNotification('Add to Cart', dataJSON.errors.send_on[0], {
                type: 'error',
                timeout: 5000
              });
              return;
            } else {
              window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
                type: 'error',
                timeout: 5000
              });
            }
            
          }

          if(recipientForm){
            document.querySelectorAll('recipient-form input:not([name="send-on"]), recipient-form textarea').forEach(element => {
                element.value = ''; 
            });

            let flatpickrInput = document.querySelector('recipient-form .flatpickr-input');
            if (flatpickrInput) {
                flatpickrInput._flatpickr.clear(); // This clears the Flatpickr input
                flatpickrInput._flatpickr.setDate(null); // Optionally set the default date or clear selection
            }
          }

    
          if(document.querySelector('#PopupModal-quickshop')){
            document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
          }
          if(qtyInput) qtyInput.value = 1;
          if(this.cartElement){
            this.cartElement.getCartData('open_drawer');
          }else{
            window.location.href = window.routes.cart_fetch_url;
          }     
      }
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.qtyBtn = this.form.querySelector('[data-qty-container]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    //this._bindSoldoutEvent();
  }

  connectedCallback() {
    // Element Connected callback
    //if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
      let selectedOptionVal = _event.target.closest('.swatch').querySelector('input').value;
      _event.target.closest('fieldset').querySelector('.selected-option').innerHTML = selectedOptionVal;

    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
        this.updateVariantStatuses();
      }
      this.updateURLandID(this.currentVariant);
      // let variantMeta = document.querySelector('[data-variant-meta-json]');
      // if(variantMeta != null){
      //   let variantMetaJSON = JSON.parse(variantMeta.innerHTML);
      //   let inventoryMetaMatch = variantMetaJSON.variantmeta.some(item => item.title === this.currentVariant.title && item.meta_inventory === item.shopify_inventory);
  
      //   if(inventoryMetaMatch){
      //     this.toggleAddButton('disable');
      //   } else {
      //     this.toggleAddButton('enable');
      //   }
      // } else {
      //   this.toggleAddButton('enable');
      // }

      this.toggleAddButton('enable');
      
      
    }
   
    
  }

  // _bindSoldoutEvent(){
  //   const productWrap = this.closest('.product-form');
  //   Shopify.optionsMap = {};
  //   this.defaultProductOptionSetup(productWrap);
  //   this.checkOptionSelection(productWrap);
  //   let var_id = this.closest('form').querySelector('[name="id"]').value;
  //   if (this.inventoryJson != undefined) {
  //     for (var item of this.inventoryJson) {
  //       if (parseInt(item.variant.id) == parseInt(var_id)) {
  //         if (item.variant_inventory_quantity <= parseInt(this.closest('form').querySelector('[data-qty-input]').value)) {
  //           this.closest('form').querySelector('[data-qty-input]').value = item.variant_inventory_quantity;
  //           if (item.variant_inventory_quantity == 1) {
  //             this.closest('form').querySelector('.btn-decrease')?.closest('[data-qty-btn]').classList.add('disabled')
  //           } else {
  //             this.closest('form').querySelector('.btn-decrease')?.closest('[data-qty-btn]').classList.remove('disabled')
  //           }
  //           this.closest('form').querySelector('.btn-increase')?.closest('[data-qty-btn]').classList.add('disabled')
  //         } else {
  //           this.closest('form').querySelector('.btn-increase')?.closest('[data-qty-btn]').classList.remove('disabled')
  //         }
  //       }
  //     }
  //   }
  // }

  // defaultProductOptionSetup(productData) {
  //   Shopify.arrayIncludes = function (e, t) {
  //     for (var n = 0; n < e.length; n++)
  //       if (e[n] == t)
  //         return !0;
  //     return !1
  //   };

  //   Shopify.uniq = function (e) {
  //     for (var t = [], n = 0; n < e.length; n++)
  //       Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
  //     return t
  //   };

  //   if(productData.closest('product-form').querySelector('[data-product-variants-json]')!=null){
  //     var productVariants = JSON.parse(productData.closest('product-form').querySelector('[data-product-variants-json]').innerText).variant;
  //     var productOptions = this.productJson?.product.options;
  //     for (var i = 0; i < productVariants.length; i++) {
  //     var variant = productVariants[i];

  //     if (variant.available && productOptions != undefined ) {
  //       // Gathering values for the 1st drop-down.
  //       if (productOptions.length === 1) {
  //         Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
  //         Shopify.optionsMap['root'].push(variant.option1);
  //         Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
  //       }

  //       // Gathering values for the 2nd drop-down.
  //       if (productOptions.length > 1) {
  //         var key = variant.option1;
  //         Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
  //         Shopify.optionsMap[key].push(variant.option2);
  //         Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
  //       }

  //       // Gathering values for the 3rd drop-down.
  //       if (productOptions.length === 3) {
  //         var key = variant.option1 + ' / ' + variant.option2;
  //         Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
  //         Shopify.optionsMap[key].push(variant.option3);
  //         Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
  //       }
  //     }
  //   }
  // }
  // }

  // // add disable class to input label
  // addDisableClassToOptionLable(productData) {
  //   var optionData = productData.querySelectorAll('[data-format] .js.product-form__input');
  //   if (optionData.length > 0) {
  //     optionData.forEach((el, i) => {
  //       var optionElement = el.querySelectorAll('.list-unstyled li');
  //       if (optionElement.length > 0) {
  //         optionElement.forEach((item, i) => {
  //           item.querySelector('label').classList.add('is--disable');
  //         })
  //       }
  //     })
  //   }
  // }

  // checkOptionSelection(productData) {
  //   this.addDisableClassToOptionLable(productData);

    
  //   var optionsCount = productData.querySelectorAll('[data-format] .js.product-form__input').length;
  //   console.log('hiiii===>>>>',optionsCount);
  //   if (optionsCount > 0) {
  //     if (optionsCount === 1 ) {
  //       if( Shopify.optionsMap["root"]){
  //         Shopify.optionsMap["root"].forEach((el, i) => {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
  //         })
  //       }
  //     } else if (optionsCount === 2) {
  //       var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
  //       var option_2 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;
  //       console.log('helloooo',Shopify.optionsMap);
  //       if (Shopify.optionsMap[option_1] != undefined ) {
  //         Shopify.optionsMap[option_1].forEach((el, i) => {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
  //         })
  //       }

  //       for (var key in Shopify.optionsMap) {
  //         if (Shopify.optionsMap[key].indexOf(option_2) != -1) {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${key}"]`).classList.remove('is--disable');
  //         }
  //       }
  //     } else if (optionsCount === 3 && Shopify.optionsMap) {
  //       var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
  //       var option_2 = productData.querySelector('[data-format] .js.product-form__input:nth-child(2) .list-unstyled input:checked').value;
  //       var option_3 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;

  //       if (Shopify.optionsMap[option_1] != undefined) {
  //         Shopify.optionsMap[option_1].forEach((el, i) => {
  //           var option2 = Shopify.optionsMap[option_1][i];
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option2}"]`).classList.remove('is--disable');
  //         })
  //       }

  //       var option2Data = `${option_1} / ${option_2}`;
  //       Shopify.optionsMap[option2Data].forEach((el, i) => {
  //         var option3 = Shopify.optionsMap[option2Data][i];
  //         productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option3}"]`).classList.remove('is--disable');
  //       })

  //       var customOption1 = [];
  //       var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:first-child .list-unstyled li');
  //       if (firstSwatchOptions.length > 0) {
  //         firstSwatchOptions.forEach((optionEl, i) => {
  //           customOption1.push(optionEl.querySelector('label').getAttribute('title'));
  //         })
  //       }
  //       customOption1.forEach((el, i) => {
  //         var customOptionName = `${el} / ${option_2}`;
  //         if (Shopify.optionsMap[customOptionName] != undefined && Shopify.optionsMap[customOptionName].indexOf(option_3) != -1) {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
  //         } else {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
  //         }
  //       })

  //       var customOption2 = [];
  //       var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:nth-child(2) .list-unstyled li');
  //       if (firstSwatchOptions.length > 0) {
  //         firstSwatchOptions.forEach((optionEl, i) => {
  //           customOption2.push(optionEl.querySelector('label').getAttribute('title'));
  //         })
  //       }
  //       customOption2.forEach((el, i) => {
  //         var customOption2Name = `${option_1} / ${el}`;
  //         if (Shopify.optionsMap[customOption2Name] != undefined && Shopify.optionsMap[customOption2Name].indexOf(option_3) != -1) {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
  //         } else {
  //           productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
  //         }
  //       })
  //     }
  //   }
  // }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form, updateOptionLabel){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
  
      const sizeMapping = {
        'S': 'Small',
        'M': 'Medium',
        'L': 'Large',
        'XL': 'Extra Large',
        'XXL': 'Extra Extra Large'
      };
  
      let optionSelectedVal = sizeMapping[this.currentVariant[labelID]];
  
      // If optionSelectedVal is undefined (meaning there's no mapping), keep the existing label
      if(optionSelectedVal === undefined) {
        if(this.currentVariant[labelID] === undefined){
          return
        } else {
          label.innerHTML = this.currentVariant[labelID];
        }
       
      } else {
        // Update the label content
        label.innerHTML = optionSelectedVal;
      }
      
      
    });
  }
  

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  // setInputAvailability(listOfOptions, listOfAvailableOptions) {
  //   console.log(listOfOptions);
  //   listOfOptions.forEach((input) => {
  //     if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
  //       input.classList.remove('disabled');
  //     } else {
  //       input.classList.add('disabled');
  //     }
  //   });
  // }


  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let price = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {

    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

   
    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;

        //change hover image
        let seletedOption;
        let options = this.form.querySelectorAll('[data-optionindex]');
        options.forEach(option => {
          let lableID = 'option'+option.dataset.optionindex;
          const lable = option.querySelector('.selected-option');
          if(!lable || !lableID) return;
          seletedOption = this.currentVariant[lableID];
        });

        let productImages = this.closest('.card').querySelectorAll('[data-product-images] img');
        let hoverImageURL;

        productImages.forEach((productImage) => {
            let altTag = productImage.getAttribute('alt');
            let altTagParts = altTag.split('#');
            let valueAfterHash = altTagParts[1];
        
            if (valueAfterHash !== undefined && seletedOption.toLowerCase() === valueAfterHash.toLowerCase()) {
                let productImageSrc = productImage.getAttribute('src');
                let currentVariantSrc = currentVariant.featured_image.src;
        
                if (productImageSrc.includes('&width=50')) {
                    productImageSrc = productImageSrc.substring(0, productImageSrc.indexOf('&width=50'));
                }
        
                if (productImageSrc !== currentVariantSrc) {
                    hoverImageURL = productImageSrc;
                }
            }
        });
      

        if(hoverImageURL){
          var modifiedURL = hoverImageURL.replace('&width=50', '');

          const hoverImage = container.querySelector('[data-hoverimage]');
          hoverImage.src = modifiedURL;
          hoverImage.srcset = modifiedURL;
        }
        //end hover image
      
      }else{
       
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
       
    
      
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);

        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }

    if(this.formType != 'quickshop'){
     
      if(currentVariant.sku){

        let variantSkuElement = document.querySelector('[data-variant-sku]');
        if (variantSkuElement) {
            variantSkuElement.textContent = currentVariant.sku;
        }
      }
      let inventoryTxtElement = document.querySelector('[data-product-inventory-txt]');

      if(currentVariant.available){
        if (inventoryTxtElement) {

          inventoryTxtElement.innerHTML = '<span class="text-success text-capitalize">In Stock</span>';
        }
      } else {
        if (inventoryTxtElement) {
          inventoryTxtElement.innerHTML = '<span class="text-danger text-capitalize">Out Of Stock</span>';
        }
      }

      let variantMeta = document.querySelector('[data-variant-meta-json]');
   
      if(variantMeta){
        let variantMetaJSON = JSON.parse(variantMeta.innerHTML);
        let variantHighlightImage = variantMetaJSON.variantmeta.find(el => el.title === currentVariant.title)?.highlight_image || '';
        let highlightImageEl = document.querySelector('.img-and-logo .highlight-image [data-highlight-img]');
        let inventoryMetaMatch = variantMetaJSON.variantmeta.some(item => item.title === currentVariant.title && item.meta_inventory === item.shopify_inventory);
        if(inventoryMetaMatch){
          inventoryTxtElement.innerHTML = '<span class="text-danger text-capitalize">Unavailable</span>';
        } 

        if(highlightImageEl != null){
          if(variantHighlightImage){
            highlightImageEl.src = variantHighlightImage;
            highlightImageEl.srcset = variantHighlightImage;
            highlightImageEl.classList.remove('d-none')
          } else {
            highlightImageEl?.classList.add('d-none')
          }
        } else if(variantHighlightImage != '') {
          let imageHTML = `
            <img
            src="${variantHighlightImage}"
            srcset="${variantHighlightImage}"
            data-highlight-img
            class="highlight-variant object-fit-contain position-absolute start-0 top-0"
            loading="lazy"
            width=""
            height=""
            >
          `;
          document.querySelector('.img-and-logo .highlight-image').innerHTML = imageHTML;

        }
        
      
      } 
    }

  
    
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      this.qtyBtn.classList.add('d-none')

      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if (this.qtyBtn) {
        this.qtyBtn.classList.add('d-none')
      }

      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        if (this.qtyBtn) {
          this.qtyBtn.classList.remove('d-none')
        }
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        //swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
}
customElements.define('variant-radios', VariantRadios);